<template>
  <div>
    <template v-if="loading">
      <div
        class="wg-row"
        style="margin: 10px; justify-content: center"
      >
        <vue-simple-spinner size="medium" line-fg-color="#0aabf4" />
      </div>
    </template>
    <template v-else>
      <div class="wg-row contact-header">
        <router-link
          :to="'/'"
        >
          <img
            class="com-anm22-app-img-fixed-height-m com-anm22-app-round"
            style="cursor:pointer;margin-right:10px;"
            :title="$anm22.strLang(lang, 'Back', 'Indietro')"
            :src="$anm22.icons.getWorldIcon('back')"
          />
        </router-link>
        <img
          :src="contact.type == 2 ? $anm22.getObjIcon(contact,'workMaterial') : $anm22.getContactIcon(contact, $store)"
          style="height:40px;margin-right:10px;"
        />
        <div @click="changePage('details');edit = false;" style="cursor:pointer;font-size:22px;">{{ $anm22.getContactName(contact, $store) }}<span v-if="$anm22.getReferrerFlag(contact, $store) == 0 && contact.type === 2">{{ $anm22.getContactReferrerName(contact, $store) }}</span></div>
        <div @click="changePage('details');edit = false;" class="tags-list">
          <div v-if="contactStatus" :style="{borderLeft : (contactStatus && contactStatus.color != '') ? '4px solid' + ' ' + contactStatus.color : ''}" class="display-flex contact-tag status">{{ contactStatus.name }}</div>
          <div v-for="(tag,index) in contactTags" :key="'tag'+index" class="display-flex contact-tag" :title="tag.label">
            <div class="color-selected" :style="{backgroundColor: tag.color}"></div>
            <div class="com-anm22-app-text-m tag-label">{{ tag.label }}</div>
          </div>
        </div>
        <div v-if="!isSynchronized" class="com-horizontal-space" style="width:12px;"></div>
        <img 
          v-if="!isSynchronized" 
          class="com-anm22-app-img-fixed-height-m"
          :src="$anm22.icons.getWorldIcon('offline')" 
          style="margin-right:5px;"
          :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
        > 
        <div class="com-horizontal-space" style="width:12px;"></div>
        <img
          v-if="canView"
          class="com-anm22-app-img-fixed-height-m"
          style="cursor:pointer;"
          :src="$anm22.icons.getWorldIcon('edit')"
          @click="editContact"
        />
        <div class="com-horizontal-space" style="width:12px;"></div>
        <img
          v-if="permission <= 3"
          class="com-anm22-app-img-fixed-height-m"
          style="cursor:pointer;"
          :src="$anm22.icons.getWorldIcon('deleteBin')"
          @click="showDeleteDialog = true;"
        />
      </div>
      <world-sub-menu
        :mode="'topbar'"
        :selected="pageId"
        :list="list"
        :restrictions="[]"
        :componentHeight="'calc(100vh - 120px)'"
        @changePage="changePage"
      >
        <div slot="content" class="wg-row">
          <wg-modal v-if="showDeleteDialog" @closeModal="showDeleteDialog = false;">
            <div class="wg-row" style="justify-content:center;" slot="body">
              <div
                class="com-anm22-app-text-xl"
              >{{ $anm22.strLang(lang, 'Delete contact?', 'Cancellare contatto?') }}</div>
              <div class="vertical-height-div" style="height:20px;"></div>
              <div class="wg-row" style="align-items:center;justify-content:center;">
                <input
                  type="button"
                  class="small com-anm22-button-blue"
                  :value="$anm22.strLang(lang, 'OK', 'OK')"
                  @click="deleteContact"
                />
                <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
                <input
                  type="button"
                  class="small com-anm22-button-red"
                  :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
                  @click="showDeleteDialog = false;"
                />
              </div>
            </div>
          </wg-modal>
          <!-- Titolo con tasti funzione -->
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- Pagina -->
          <div class="wg-row com-anm22-app-scrolling-panel" style="height:calc(100% - 10px);">
            <component
              :key="'sub-comp-' + contactId"
              @changePage="changePage"
              @reset="$emit('reset')"
              :contactId="contactId"
              :edit="edit"
              :canView="canView"
              @endEdit="edit = false"
              :is="selected"
              :userPermission="permission"
            ></component>
          </div>
        </div>
      </world-sub-menu>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldSubMenu from "../../../../world/spa/components/WorldSubMenu.vue";
import ContactDetails from "../components/ContactDetails.vue";
import ContactPlaces from "../components/ContactPlaces.vue";
import ContactFeed from "../components/ContactFeed.vue";
import ContactProjects from "../components/ContactProjects.vue";
import ContactStatistics from "../components/ContactStatistics.vue";
import ContactFiles from "../components/ContactFiles.vue";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    contactId: [String, Number],
  },
  data() {
    return {
      selected: "ContactFeed",
      pageId: "feed",
      loading: true,
      showDeleteDialog: false,
      edit: false,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      windowWidth: state => state.windowWidth,
    }),
    contact() {
      const c = this.$store.getters["contacts/get"](this.contactId);
      if (c) {
        return c;
      } else {
        this.$emit("reset");
      }
    },
    isSynchronized() {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('ContactsContact' + this.contactId));
    },
    permission() {
      if (this.contact && this.contact.workOwner) {
        return this.$store.getters["employments/getPermByWork"](
          this.contact.workOwner
        );
      } else {
        return 1;
      }
    },
    customerManagers() {
      if (this.contact.managers) {
        return this.contact.managers.map(m =>
          this.$store.getters["users/get"](m)
        );
      } else {
        return [];
      }
    },
    canView() {
      if (this.license && this.license.work == 474) {
        return (
          this.permission <= 3 ||
          (this.permission > 3 &&
            !!this.customerManagers.find(
              u => u.idWorldUser === this.user.idWorldUser
            ))
        );
      } else {
        return true;
      }
    },
    license() {
      if (this.contact && this.contact.workOwner) {
        return this.$store.getters["licenses/getByWork"](
          this.contact.workOwner
        );
      } else {
       return [];
      }
    },
    list() {
      let list = [
        {
          id: "feed",
          img: this.$anm22.icons.getWorldIcon("chat"),
          label: this.$anm22.strLang(this.lang, "Feed", "Feed"),
          component: "ContactFeed"
        },
        {
          id: "details",
          img: this.$anm22.icons.getWorldIcon("list"),
          label: this.$anm22.strLang(this.lang, "Details", "Dettagli"),
          component: "ContactDetails"
        },
        {
          id: "places",
          img: this.$anm22.icons.getWorldIcon("placeBlack"),
          label: this.$anm22.strLang(this.lang, "Address", "Indirizzo"),
          component: "ContactPlaces"
        },
        {
          id: "projects",
          img: this.$anm22.icons.getTasksIcon("tasksBlack"),
          label: this.$anm22.strLang(this.lang, "Projects", "Progetti"),
          component: "ContactProjects"
        },
      ];
      if (this.contact.workOwner != 474) {
        list.push({
          id: "docs",
          img: this.$anm22.icons.getWorldIcon("fileDefault"),
          label: this.$anm22.strLang(this.lang, "Documents", "Documenti"),
          component: "ContactFiles"
        });
      }
      if(!this.contact || this.contact.workOwner != 474) {
        list.push({
          id: "statistics",
          img: this.$anm22.icons.getTasksIcon("statisticsBlack"),
          label: this.$anm22.strLang(this.lang, "Statistics", "Statistiche"),
          component: "ContactStatistics"
        });
      } else {
        if(this.permission <= 3) {
          list.push({
            id: "statistics",
            img: this.$anm22.icons.getTasksIcon("statisticsBlack"),
            label: this.$anm22.strLang(this.lang, "Statistics", "Statistiche"),
            component: "ContactStatistics"
          });
        }
      }
      // Tabs custom
      // Add list element
      if (
        this.license &&
        this.license.config &&
        this.license.config.contacts &&
        this.license.config.contacts["contact-custom-tabs"]
      ) {
        const tabs = this.license.config.contacts["contact-custom-tabs"];
        tabs.forEach((t, i) => {
          list.push({
            id: "custom-" + i,
            img: this.$anm22.icons.getWorldIcon("tag"),
            label: this.$anm22.strLang(this.lang, t.label.en, t.label.it),
            component: () => import("../components/custom/" + t.component)
          });
        });
      }
      return list;
    },
    contactTags() {
      if (this.contact.tags && this.contact.tags.length > 0) {
        return this.contact.tags.map(tId =>this.$store.getters["tags/get"](tId)).filter(t => t);
      } else {
        return [];
      }
    },
    tags(){
      return this.$store.getters['tags/getAll'];
    },
    contactStatus() {
      if (this.contact && this.contact.status) {
        return this.$store.getters['contactsStatus/get'](this.contact.status);
      } else {
        return null;
      }
    },
  },
  methods: {
    lastClickContact() {
      this.$http
        .post("contact/last-feed-view", {
          contactId: this.contactId
        }, {
          withCredentials: true
        })
        .then((response) => {
          const contact = this.$store.getters["contacts/get"](this.contactId);
          contact.lastOpen = response.data.contact.lastOpen;
          this.$store.dispatch("contacts/update", {
            vlf: this.$vlf("contacts"),
            objs: [contact],
          });
        });
    },
    changePage(elem) {
      if (typeof elem == "string") {
        elem = this.list.find(l => l.id === elem);
      }
      this.pageId = elem.id;
      this.selected = elem.component;
    },
    loadData() {
      Promise.all([
        this.$store.dispatch("contacts/load", this.$vlf("contacts")),
        this.$store.dispatch("contactPlaceAssocs/load", this.$vlf("contactPlaceAssocs")),
        this.$store.dispatch("users/load", this.$vlf("users")),
        this.$store.dispatch("places/load", this.$vlf("places")),
        this.$store.dispatch("projects/load", this.$vlf("projects")),
        this.$store.dispatch("files/load", this.$vlf("files")),
        this.$store.dispatch("works/load", this.$vlf("works")),
        this.$store.dispatch("licenses/load", this.$vlf("licenses")),
        this.$store.dispatch("employments/load", this.$vlf("employments")),
        this.$store.dispatch("contactsStatus/load", this.$vlf("contactsStatus")),
        this.$store.dispatch("contactsCompetitors/load", this.$vlf("contactsCompetitors")),
        this.$store.dispatch("contactsLeadChannel/load", this.$vlf("contactsLeadChannel")),
        this.$store.dispatch("contactsAbandoned/load", this.$vlf("contactsAbandoned")),
        this.$store.dispatch("tags/load", this.$vlf("tags")),
      ])
        .then(() => {
          this.loading = false;
          document.title = this.$anm22.getContactName(
            this.contact,
            this.$store
          ) + ' | ANM22 Contacts';
        })
        .catch(error => console.log(error));
    },
    showDial() {
      this.$emit("showDialog");
    },
    editContact() {
      this.changePage("details");
      this.edit = true;
    },
    deleteContact() {
      this.$http
        .post("contact/delete", {
          contactId: this.contact.idContactsContact
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.contact) {
            Promise.all([
              ...this.contact.places.map(p =>
                this.$store.dispatch("places/delete", {
                  vlf: this.$vlf("places"),
                  obj: this.$store.getters["places/get"](p)
                })
              ),
              this.$store.dispatch("contacts/delete", {
                vlf: this.$vlf("contacts"),
                obj: response.data.contact
              })
            ]).then(() => {
              this.$anm22.eventBus.$emit("wg-modal-close");
              this.$router.push({ path: `/contact/` });
            });
          } else {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "Impossible to delete contact with associated projects",
                "Impossibile cancellare contatto con progetti associati"
              ),
              type: "warning"
            });
            this.$anm22.eventBus.$emit("wg-modal-close");
          }
        })
        .catch(error => console.log(error));
    },
    refresh() {
      this.$http
        .get("contact?idContactsContact=" + this.contactId)
        .then(response => {
          if (response.data) {
            Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [response.data.contact]
              }),
              this.$store.dispatch("contactPlaceAssocs/update", {
                vlf: this.$vlf("contactPlaceAssocs"),
                objs: response.data.contactPlaceAssocs
              }),
              this.$store.dispatch("projects/update", {
                vlf: this.$vlf("projects"),
                objs: response.data.projects,
              }),
              this.$store.dispatch("files/update", {
                vlf: this.$vlf("files"),
                objs: response.data.files,
              }),
              this.$store.dispatch("users/update", {
                vlf: this.$vlf("users"),
                objs: response.data.users
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: response.data.places
              }),
              this.$store.dispatch("works/update", {
                vlf: this.$vlf("works"),
                objs: response.data.works
              }),
              this.$store.dispatch("licenses/update", {
                vlf: this.$vlf("licenses"),
                objs: response.data.licenses
              }),
              this.$store.dispatch("employments/update", {
                vlf: this.$vlf("employments"),
                objs: response.data.employments
              }),
              this.$store.dispatch("contactsStatus/update", {
                vlf: this.$vlf("contactsStatus"),
                objs: response.data.contactsStatus
              }),
              this.$store.dispatch("contactsCompetitors/update", {
                vlf: this.$vlf("contactsCompetitors"),
                objs: response.data.contactsCompetitors
              }),
              this.$store.dispatch("contactsLeadChannel/update", {
                vlf: this.$vlf("employcontactsLeadChannelments"),
                objs: response.data.contactsLeadChannel
              }),
              this.$store.dispatch("contactsAbandoned/update", {
                vlf: this.$vlf("contactsAbandoned"),
                objs: response.data.contactsAbandoned
              }),
              this.$store.dispatch("tags/update", {
                vlf: this.$vlf("tags"),
                objs: response.data.tags
              }),
            ])
              .then(() => {
                this.loading = false;
                document.title = this.$anm22.getContactName(
                  this.contact,
                  this.$store
                ) + ' | ANM22 Contacts';
                this.lastClickContact();
              })
              .then(() => {
                this.$store.dispatch("offline/sync", {
                  _vue: this,
                  blocking: false
                });
            })
              .catch(error => console.log(error));
          } else {
            this.$router.push("/");
          }
        });

      /* Paglierani - Download dettagli contatto */
      if (this.contact && this.contact.workOwner == 965) {
        this.$http
          .get("paglierani?idContactsContact=" + this.contactId)
          .then(response => {
            if (response.data) {
              Promise.all([
                this.$store.dispatch("paglieraniContactPricing/update", {
                  vlf: this.$vlf("paglieraniContactPricing"),
                  objs: response.data.contactPricing,
                }),
                this.$store.dispatch("projects/update", {
                  vlf: this.$vlf("projects"),
                  objs: response.data.projects,
                }),
                this.$store.dispatch("users/update", {
                  vlf: this.$vlf("users"),
                  objs: response.data.users
                }),
              ])
                .catch(error => console.log(error));
            }
          });
      }
    }
  },
  created() {
    this.loading = true;
    this.loadData();
    this.refresh();
  },
  watch: {
    contactId(newVal, oldVal) {
      this.edit = false;
      this.refresh();
    }
  },
  components: {
    ContactDetails,
    ContactPlaces,
    ContactFeed,
    ContactProjects,
    ContactStatistics,
    ContactFiles,
    WorldSubMenu,
    "vue-simple-spinner": Spinner,
  }
};
</script>

<style lang="scss" scoped>
.contact-header {
  flex-wrap:nowrap;
  align-items:center;
  justify-content:center;
  border-bottom: 1px solid #ddd;
  height: 60px;
}
@media (max-width: 767px) {
  .contact-header {
    background-color: #eee;
    border-bottom: 0;
  }
}

.tags-list {
  align-items:center;
  justify-content:center;
  width:auto;
  margin-left:6px;
  flex-wrap: wrap;
  display: flex;
  display: -webkit-flex;
  -ms-box-orient: horizontal;
  cursor: pointer;

  .contact-tag {
    background: none;
    padding: 10px 0;
    font-size: 14px;
    border-radius: 10px;
    margin-right: 0;
    flex-wrap: nowrap;
    align-items: center;
    position: relative;
    width:9px;

    .color-selected {
      border-radius: 50%;
      width:12px;
      height:12px;
      position: absolute;
      top: 5px;
      left: 0;
      border: 1px solid #eee;
    }

    .tag-label {
      display: none;
      margin-left:10px;
    }

    &.status {
      background-color: #ddd;
      padding: 10px;
      width: auto;
      margin-right: 6px;

      .color-selected {
        position: static;
        border: 1px solid #ddd;
      }
      .tag-label {
        display: block;
      }
    }
  }
}

@media (min-width: 768px) {
  .tags-list {
    .contact-tag:hover {
      background-color: #ddd;
      padding: 10px;
      width: auto;

      .color-selected {
        position: static;
        border: 1px solid #ddd;
      }
      .tag-label {
        display: block;
      }
    }
  }
}

.referrer {
  margin-left: 2%;
}
</style>
